export const CREATE_ERROR = 'quotes/CREATE_ERROR';
export const DELETE_ERROR = 'quotes/DELETE_ERROR';
export const CREATE_FATAL_ERROR = 'quotes/CREATE_FATAL_ERROR';
export const DELETE_FATAL_ERROR = 'quotes/DELETE_FATAL_ERROR';


// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/vuex/errors/mutation-types.js